const MONTH_NAMES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export function monthLabel(month) {
  return MONTH_NAMES[month - 1] || `Mes ${month}`;
}

function pickNum(obj, ...keys) {
  for (const key of keys) {
    if (obj[key] != null && obj[key] !== '') {
      const n = Number(obj[key]);
      if (!Number.isNaN(n)) return n;
    }
  }
  return null;
}

export function formatHours(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  return n.toLocaleString('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
}

export function normalizeYearTotals(totals) {
  if (!totals) return null;
  return {
    working_days: pickNum(totals, 'working_days', 'WorkingDays') ?? 0,
    holiday_days: pickNum(totals, 'holiday_days', 'HolidayDays') ?? 0,
    vacation_days: pickNum(totals, 'vacation_days', 'VacationDays') ?? 0,
    absence_days: pickNum(totals, 'absence_days', 'AbsenceDays') ?? 0,
    theoretical_hours: pickNum(totals, 'theoretical_hours', 'TheoreticalHours') ?? 0,
    actual_hours: pickNum(totals, 'actual_hours', 'ActualHours') ?? 0,
    overtime_hours: pickNum(totals, 'overtime_hours', 'OvertimeHours') ?? 0,
  };
}

export function formatCellDays(value) {
  if (value == null) return '—';
  return String(value);
}

/** Normaliza un registro mensual del API (snake_case o PascalCase). */
export function normalizeMonthRecord(m) {
  if (!m) return null;
  const month = Number(m.month ?? m.Month);
  if (!month || month < 1 || month > 12) return null;
  return {
    month,
    working_days: pickNum(m, 'working_days', 'WorkingDays'),
    holiday_days: pickNum(m, 'holiday_days', 'HolidayDays'),
    vacation_days: pickNum(m, 'vacation_days', 'VacationDays'),
    absence_days: pickNum(m, 'absence_days', 'AbsenceDays'),
    theoretical_hours: pickNum(m, 'theoretical_hours', 'TheoreticalHours'),
    actual_hours: pickNum(m, 'actual_hours', 'ActualHours'),
    overtime_hours: pickNum(m, 'overtime_hours', 'OvertimeHours'),
  };
}

export function buildMonthlyRows(summary) {
  const monthsRaw = summary?.months ?? summary?.Months ?? [];
  const byMonth = {};
  monthsRaw.forEach((raw) => {
    const m = normalizeMonthRecord(raw);
    if (m) byMonth[m.month] = m;
  });

  return Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    const row = byMonth[month];
    return {
      month,
      label: monthLabel(month),
      hasData: Boolean(row),
      working_days: row?.working_days ?? null,
      holiday_days: row?.holiday_days ?? null,
      vacation_days: row?.vacation_days ?? null,
      absence_days: row?.absence_days ?? null,
      theoretical_hours: row?.theoretical_hours ?? null,
      actual_hours: row?.actual_hours ?? null,
      overtime_hours: row?.overtime_hours ?? null,
    };
  });
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  const [y, mo, d] = dateStr.split('-').map(Number);
  if (!d || !mo) return dateStr;
  return `${String(d).padStart(2, '0')}/${String(mo).padStart(2, '0')}`;
}

export function formatWeekRange(from, to) {
  if (!from || !to) return '';
  return `${formatDateShort(from)} – ${formatDateShort(to)}`;
}

const VALIDATION_LABELS = {
  approved: 'Aprobado',
  pending: 'Pendiente',
  rejected: 'Rechazado',
};

export function validationLabel(status) {
  if (!status) return '—';
  return VALIDATION_LABELS[status] || status;
}

const STATUS_LABELS = {
  present: 'Presente',
  absent: 'Ausente',
  late: 'Tarde',
  rejected: 'Rechazado',
};

export function attendanceStatusLabel(status) {
  if (!status) return '—';
  return STATUS_LABELS[status] || status;
}

export function dayTypeLabel(day) {
  if (day.is_on_absence) {
    const types = {
      vacation: 'Vacaciones',
      sick_leave: 'Baja médica',
      maternity: 'Maternidad',
      training: 'Formación',
      special_leave: 'Permiso',
      unpaid_leave: 'Excedencia',
    };
    return types[day.absence_type] || day.planned_shift || 'Ausencia';
  }
  if (day.is_holiday) return 'Festivo';
  if (!day.is_working_day) return 'Descanso';
  return day.planned_shift || 'Laborable';
}
